var render = function render(){var _vm=this,_c=_vm._self._c;return _c('notification-base-list',{attrs:{"extra-list-params":_vm.ExtraListParams,"extra-columns":_vm.ExtraColumns,"extra-filter-options":_vm.ExtraFilterOptions,"id":_vm.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }